import { render, staticRenderFns } from "./BuilderCanvas.vue?vue&type=template&id=7f682ab7&"
import script from "./BuilderCanvas.vue?vue&type=script&lang=js&"
export * from "./BuilderCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports